import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { formItem } from '../preview-forms/preview-forms.interface';

@Component({
    selector: 'app-validate-items',
    templateUrl: './validate-items.component.html',
    styleUrls: ['./validate-items.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValidateItemsComponent implements OnChanges {
  // nameItem: any;
  // @Input('formname') set item(v: any) {
  //   // console.log(this.nameItem);

  //   this.nameItem = v.question_name || '';
  // }
  validateAction: boolean = false;
  @Input('action') set valAction(v: any) {
    this.validateAction = v;
  }

  validItem: any;
  @Input('valid') set value(v: any) {
    this.validItem = v
    if (this.validateAction && !this.validItem || this.validItem == "") {
      this.ValidDate();
    }
  }

  @Output('validUpdate') validUpdate = new EventEmitter();




  ngOnChanges() {
    if (this.validateAction && this.validItem) {
      this.validateAction = false;
      this.validUpdate.emit(false)
    }
  }


  ValidDate() {
    this.validateAction = true
    this.validUpdate.emit(true)
  }
}
